import React from 'react'
import Login2 from '../Components/LoginFloder/Login2'
import Header from '../Components/LoginFloder/Header'

const Signin2 = () => {
  return (
    <div>
        <Header />
        <Login2 />
    </div>
  )
}

export default Signin2